import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=c0c0fbb8&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=c0c0fbb8&scoped=true&lang=css&"
import style1 from "./Gallery.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0fbb8",
  null
  
)

export default component.exports